export default {
  'commissionmanagement.commissionmanagement': 'Gestione punti',
  'commissionmanagement.accountsnotify': 'Per Favore Crea un Conto Bancario Da',
  'commissionmanagement.accountsnotify1':
    'Clicca Se Non si Dispone di Alcun Conto',
  'commissionmanagement.accountmanagement': 'Gestione del Conto Bancario',
  'commissionmanagement.description': 'Descrizioni',
  'commissionmanagement.bankaccount': 'Numero del Conto',
  'commissionmanagement.save': 'Salva',
  'commissionmanagement.addrequest': 'invia richiesta di prelievo',
  'commissionmanagement.withdrawamount': 'Importo del Prelievo',
  'commissionmanagement.index': 'Indice',
  'commissionmanagement.requestdate': 'Data della Richiesta',
  'commissionmanagement.requeststatus': 'Stato della Richiesta',
  'commissionmanagement.withdrawtype': 'Tipo di Prelievo',
  'commissionmanagement.requestadd':
    'La richiesta di Prelievo è Stata Aggiunta Correttamente',
  'commissionmanagement.tryagain': 'Per Favore Riprova',
  'commissionmanagement.deleterequest': 'Elimina Richiesta di Prelievo',
  'commissionmanagement.deleteerror, commissionmanagement.disapprove':
    'Impossibile Eliminare Questa Richiesta , Disapprova',
  'commissionmanagement.approve': 'Approvato',
  'commissionmanagement.disapprove': 'disapprove',
  'commissionmanagement.pending': 'In sospeso',
  'commissionmanagement.notpaid': 'Non è stato Pagato',
  'commissionmanagement.paid': 'Pagato',
  'commissionmanagement.showdetail': 'Mostra dettagli',
  'commissionmanagement.incomedetail': 'Dettagli sul reddito',
  'commissionmanagement.withdrawreport': 'Report delle transazioni',
  'commissionmanagement.transferpoints': 'punti di trasferimento',
  'commissionmanagement.buycard': 'comprare una scheda telefonica',
  'commissionmanagement.paybill': 'pagare il conto',
  'commissionmanagement.spendpoints': 'Punto di spesa',
  'commissionmanagement.lottery': 'Lotteria',
  'commissionmanagement.earnpoints': 'Guadagna punto',
  'commissionmanagement.redandantrequest':
    "C'è una richiesta in sospeso. Non inviare un'altra richiesta",
  'commissionmanagement.exitfee': 'Pagamento della tassa di uscita',
  'commissionmanagement.requestreport': 'Rapporto sulle richieste di prelievo',
  'commissionmanagement.phrase': 'Numero del documento',
  'commissionmanagement.documentdescription': 'Descrizione del documento',
  'commissionmanagement.transferamount': 'Punti trasferibili',
  'commissionmanagement.pointamount': 'Importo del punto',
  'commissionmanagement.secondpassword': 'Seconda password',
  'commissionmanagement.transfererror':
    'La quantità di punti richiesti è superiore alla quantità di punti rimanenti',
  'commissionmanagement.resecondpassword': 'Riscrivi la seconda password',
  'commissionmanagement.wagenotify1': 'Accetti di detrarre ',
  'commissionmanagement.wagenotify2': ' punto per lo stipendio? ',
  'commissionmanagement.errorsecondpassword':
    'La seconda password non è registrata. Per favore inserisci prima la seconda password',
  'commissionmanagement.wrongsecondpassword':
    'La seconda password è sbagliata!',
  'commissionmanagement.successtransfer': 'Punti trasferiti con successo',
  'commissionmanagement.notenoughpoint':
    'I punti richiesti non sono consentiti a causa dei tuoi punti sospesi',
  'commissionmanagement.sameprofiles':
    'Il mittente è lo stesso del destinatario',
  'commissionmanagement.deleteconfirm':
    'Sei sicuro di cancellare la richiesta di ritiro dei punti?',
  'commissionmanagement.deletesucess':
    'La richiesta di prelievo è stata eliminata correttamente',
  'commissionmanagement.customer': 'Cliente',
  'commissionmanagement.employee': 'Dipendenti',
  'commissionmanagement.request': 'Richieste',
  'commissionmanagement.income': 'Il tuo reddito',
  'commissionmanagement.wallet': 'Aggiorna il tuo portafoglio',
  'commissionmanagement.customerregion': 'Regione basata sul cliente',
  'commissionmanagement.totalpoint': 'Punti totali',
  'commissionmanagement.requestprice': 'Importo richiesto',
  'commissionmanagement.sendsms': 'Inviare SMS',
  'commissionmanagement.requestpoint': 'Punto richiesto',
  'commissionmanagement.wallettransaction':
    'Ultime transazioni del portafoglio',
  'commissionmanagement.recenttransactions': 'Le transazioni recenti',
  'commissionmanagement.pointtransactions': 'Transazioni di punti',
  'commissionmanagement.transitional': 'di transizione',
  'commissionmanagement.exitfeepayment': 'Commissione di uscita dal pagamento',
  'commissionmanagement.moneydescription':
    'Puoi convertire i tuoi punti in denaro e depositarli sul tuo conto in banca.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'In questo modo puoi trasferire i tuoi punti agli utenti Tripsi.',
  'commissionmanagement.transferpointdescriptionTripord':
    'In questo modo puoi trasferire i tuoi punti agli utenti Tripord.',
  'commissionmanagement.getpointdescription':
    'Ci sono diversi modi per aumentare i tuoi punti e avere viaggi gratis.',
  'commissionmanagement.spendpointdescription':
    'Puoi utilizzare i tuoi punti in diverse sezioni e avere servizi gratuiti .',
  'commissionmanagement.buycarddescription':
    'Attraverso i punti, puoi ricevere gratuitamente la carta di Hamrah Aval, Irancell e Taliya.',
  'commissionmanagement.exitfeedescription':
    'Con i tuoi punti puoi pagare le tasse di uscita.',
  'commissionmanagement.transfermoney': 'Trasferire denaro',
  'commissionmanagement.buypoint': 'Acquista punto',
  'commissionmanagement.safeway': 'Il modo più sicuro',
  'commissionmanagement.spendanywhere': 'Spendi ovunque',
  'commissionmanagement.deposit': 'Deposito su conto',
  'commissionmanagement.easyway': 'La via più facile',
  'commissionmanagement.fastway': 'Il modo più veloce',
  'commissionmanagement.entersecondpassword': 'Immettere la seconda password',
  'commissionmanagement.usepoint': 'Mio caro amico, usa bene i punti',
  'commissionmanagement.buyCard': 'Acquista carta',
  'commissionmanagement.textRequest':
    'Puoi convertire i tuoi punti in denaro tramite il modulo sottostante.',
  'commissionmanagement.textTransferpoints':
    'Puoi trasferire i tuoi punti su un altro account utente tramite il modulo sottostante.',
  'commissionmanagement.InternalServer': 'Errore interno del server',
};
